
// // DiscoverPage.jsx
// import React, { useEffect, useState } from "react";
// import "../CSS/discover.css";
// import Chart from "chart.js/auto";
// import { Link } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import ProjectPlaceholder from "../images/logo.png"; //  default image

// const DiscoverPage = () => {
//   const [projects, setProjects] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [analyticsChart, setAnalyticsChart] = useState(null);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   useEffect(() => {
//     loadProjects();
//   }, []);

//   // Fetch only approved projects
//   const loadProjects = async () => {
//     try {
//       const response = await fetch("http://localhost:8000/api/projects/approved");
//       if (response.ok) {
//         const data = await response.json();
//         setProjects(data);
//       }
//     } catch (err) {
//       console.error("Error loading projects:", err);
//     }
//   };

//   // Filter projects by search term
//   const filteredProjects = projects.filter((p) =>
//     p.title?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Open analytics modal
//   const openAnalytics = (project) => {
//     setSelectedProject(project);
//     const ctx = document.getElementById("analytics-chart").getContext("2d");
//     if (analyticsChart) analyticsChart.destroy();

//     const chart = new Chart(ctx, {
//       type: "bar",
//       data: {
//         labels: ["Invested", "Current Value", "ROI", "Next Payment"],
//         datasets: [
//           {
//             label: project.title,
//             data: [
//               project.totalContributions || 0,
//               project.currentValue || 0,
//               project.roi || 0,
//               project.nextPaymentAmount || 0,
//             ],
//             backgroundColor: ["#FF3CAC", "#784BA0", "#2B86C5", "#FFB800"],
//           },
//         ],
//       },
//       options: {
//         responsive: true,
//         plugins: {
//           legend: { display: false },
//           tooltip: { enabled: true },
//         },
//       },
//     });

//     setAnalyticsChart(chart);
//     document.getElementById("analytics-modal").style.display = "block";
//   };

//   const closeAnalytics = () => {
//     document.getElementById("analytics-modal").style.display = "none";
//   };

//   return (
//     <>
//       <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       />

//       <main className="dc-main-content">
//         {/* Page Header */}
//         <div className="dc-page-header">
//           <h1 className="dc-page-title">
//             <i className="fas fa-project-diagram"></i> Discover Film Contributions
//           </h1>

//           <div className="dc-search-bar-container">
//             <i className="fas fa-search"></i>
//             <input
//               type="text"
//               id="project-search"
//               className="dc-form-control"
//               placeholder="Search by project title..."
//               autoComplete="off"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <button className="search-icon-btn" type="button"></button>
//           </div>
//         </div>

//         {/* Discover Grid - Dynamic Projects */}
//         <div className="discover-container">
//           {filteredProjects.length > 0 ? (
//             filteredProjects.map((project) => (
//               <div key={project.ProjectID} className="discover-card">
//                 <div className="discover-image-wrapper">
//                   <img
//                     src={project.posterUrl || ProjectPlaceholder}
//                     alt={project.title}
//                     className="discover-image"
//                   />
//                 </div>

//                 <h3 className="discover-title">{project.title}</h3>
//                 <p className="discover-subtitle">
//                   {project.language}  {project.type}  Goal: 
//                   {project.fundingGoal?.toLocaleString() || "N/A"}
//                 </p>

//                 <p><strong>English Title:</strong> {project.englishTitle || "-"}</p>
//                 <p><strong>About:</strong> {project.aboutProject || "-"}</p>
//                 <p><strong>Timeline:</strong> {project.timeline || "-"}</p>
//                 <p><strong>Min. Contribution:</strong> {project.minContribution || "-"}</p>
//                 <p><strong>Target Audience:</strong> {project.targetAudience || "-"}</p>
//                 <p><strong>Potential Profit:</strong> {project.profitPlan ? `${project.profitPlan}%` : "N/A"}</p>

//                 <div className="discover-actions">
//                   <Link to={`/project/${project.ProjectID}`} className="discover-btn details">
//                     <i className="fas fa-info-circle"></i> More Details
//                   </Link>

//                   <Link to="/contribution" className="discover-btn contribute">
//                     <i className="fas fa-hand-holding-heart"></i> Contribute Now
//                   </Link>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p>No approved projects found.</p>
//           )}
//         </div>

//         {/* Analytics Modal */}
//         <div id="analytics-modal" className="analytics-modal">
//           <div className="analytics-content">
//             <div className="close-modal" onClick={closeAnalytics}>
//               <i className="fas fa-times"></i>
//             </div>

//             <div className="analytics-header">
//               <h2 className="analytics-title">{selectedProject?.title}</h2>
//               <div className="analytics-subtitle">Detailed performance metrics</div>
//             </div>

//             <div className="chart-container">
//               <canvas id="analytics-chart"></canvas>
//             </div>

//             <div className="analytics-stats">
//               <div className="stat-card">
//                 <div className="stat-label">Total Contributions</div>
//                 <div className="stat-value">
//                   {selectedProject?.totalContributions || 0}
//                 </div>
//               </div>
//               <div className="stat-card">
//                 <div className="stat-label">Current Value</div>
//                 <div className="stat-value">
//                   {selectedProject?.currentValue || 0}
//                 </div>
//               </div>
//               <div className="stat-card">
//                 <div className="stat-label">ROI</div>
//                 <div className="stat-value">{selectedProject?.roi || 0}%</div>
//               </div>
//               <div className="stat-card">
//                 <div className="stat-label">Next Payment</div>
//                 <div className="stat-value">{selectedProject?.nextPayment || "-"}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </>
//   );
// };

// export default DiscoverPage;




// DiscoverPage.jsx
import React, { useEffect, useState } from "react";
import "../CSS/discover.css";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import ProjectPlaceholder from "../images/logo.png"; //  default image
import { BASE_API_URL } from "../constants";


const DiscoverPage = () => {
  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedProjects, setExpandedProjects] = useState({});
  const navigate = useNavigate();

  const toggleExpand = (projectId) => {
    setExpandedProjects((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  useEffect(() => {
    loadProjects();
  }, []);

  // Fetch only approved projects
  const loadProjects = async () => {
    try {
      //  FIX: Use relative path.
      // /api/projects route (in contributor backend) already filters for "Approved"
      const response = await fetch(`${BASE_API_URL}/api/projects`);
      if (response.ok) {
        const data = await response.json();
        setProjects(data);
      }
    } catch (err) {
      console.error("Error loading projects:", err);
    }
  };

  // Filter projects by search term
  const filteredProjects = projects.filter((p) =>
    p.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedProject = null;
  const closeAnalytics = () => { };

  return (
    <>
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />

      <main className="dc-main-content">
        {/* Page Header */}
        <div className="dc-page-header">
          <h1 className="dc-page-title">
            <i className="fas fa-project-diagram"></i> Discover Film Contributions
          </h1>

          <div className="dc-search-bar-container">
            <i className="fas fa-search"></i>
            <input
              type="text"
              id="project-search"
              className="dc-form-control"
              placeholder="Search by project title..."
              autoComplete="off"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className="search-icon-btn" type="button"></button>
          </div>
        </div>

        {/* Discover Grid - Dynamic Projects */}
        <div className="projects-grid">
          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <div key={project.ProjectID} className="discover-card" style={{ padding: 0, background: "transparent", boxShadow: "none", display: "flex", flexDirection: "column" }}>
                {/* Image Section */}
                <div style={{ position: "relative", width: "100%", marginBottom: "1.5rem" }}>
                  {project.posters && project.posters.length > 0 && project.posters[0] ? (
                    <img
                      src={
                        project.posters[0].startsWith("http")
                          ? project.posters[0]
                          : `${BASE_API_URL}${project.posters[0]}`
                      }
                      alt={project.title}
                      loading="lazy"
                      onError={(e) => {
                        console.error("Image failed to load:", e.target.src);
                        e.target.src = ProjectPlaceholder;
                      }}
                      style={{ width: "100%", height: "auto", display: "block" }}
                    />
                  ) : (
                    <img
                      src={ProjectPlaceholder}
                      alt="Cinevestor Logo"
                      style={{ width: "100%", height: "auto", display: "block" }}
                    />
                  )}
                  <span style={{ position: "absolute", bottom: "10px", right: "10px", background: "linear-gradient(90deg, #ec4899, #3b82f6)", color: "white", padding: "4px 12px", borderRadius: "20px", fontSize: "0.75rem", fontWeight: "bold", letterSpacing: "1px" }}>
                    {project.stage ? project.stage.toUpperCase() : "DEVELOPMENT"}
                  </span>
                </div>

                {/* Type & Title */}
                <div style={{ textAlign: "center", marginBottom: "0.5rem" }}>
                  <span style={{ color: "#e53170", fontSize: "0.85rem", fontWeight: "800", letterSpacing: "1px", textTransform: "uppercase" }}>
                    {project.type || "MOVIES"}
                  </span>
                </div>
                <h3 style={{ textAlign: "center", fontSize: "1.2rem", margin: "0.5rem 0 1rem 0", fontWeight: "bold", color: "#ffffff" }}>
                  {project.title}
                </h3>

                {/* Description */}
                <div style={{ textAlign: "center", fontSize: "0.85rem", color: "#d1d5db", marginBottom: "1.5rem", lineHeight: "1.5", padding: "0 10px" }}>
                  {expandedProjects[project.ProjectID] || (project.aboutProject && project.aboutProject.length <= 120)
                    ? project.aboutProject
                    : project.aboutProject
                    ? `"${project.aboutProject.substring(0, 120)}..."`
                    : "..."}
                  {project.aboutProject && project.aboutProject.length > 120 && (
                    <span onClick={() => toggleExpand(project.ProjectID)} style={{ color: "#2ecc71", cursor: "pointer", fontWeight: "500", marginLeft: "5px" }}>
                      {expandedProjects[project.ProjectID] ? "Read less" : "Read more"}
                    </span>
                  )}
                </div>

                {/* Progress Bar */}
                <div style={{ marginBottom: "1.5rem", padding: "0 10px" }}>
                  <div style={{ width: "100%", height: "4px", backgroundColor: "#374151", borderRadius: "2px", marginBottom: "8px" }}>
                    <div style={{ width: "0%", height: "100%", backgroundColor: "#e53170", borderRadius: "2px" }}></div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.75rem", color: "#9ca3af", fontWeight: "500" }}>
                    <span>0% Funded</span>
                    <span>{project.fundingGoal ? project.fundingGoal.toLocaleString() : "2,00,00,000"}</span>
                  </div>
                </div>

                {/* Meta Info Grid */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", textAlign: "center", fontSize: "0.8rem", color: "#ffffff", marginBottom: "1.5rem", fontWeight: "600", padding: "0 10px" }}>
                  <div><span style={{color: "#fff"}}>Min:</span> {project.minContribution || "5000"}</div>
                  <div><span style={{color: "#fff"}}>Lang:</span> {project.language || "Hindi"}</div>
                  <div><span style={{color: "#fff"}}>Timeline:</span> {project.timeline || "March 2027"}</div>
                  <div><span style={{color: "#fff"}}>Profit:</span> upto {project.profitPlan ? `${project.profitPlan}%` : "25%"}</div>
                </div>

                {/* Buttons Container */}
                <div style={{ background: "rgba(255, 255, 255, 0.03)", padding: "15px", borderRadius: "8px", display: "flex", gap: "10px", marginTop: "auto" }}>
                  <Link
                    to={`/project/${project.ProjectID}/${encodeURIComponent(project.title.replace(/\s+/g, "-"))}`}
                    style={{ flex: 1, textAlign: "center", borderRadius: "6px", background: "transparent", color: "#ec4899", border: "1px solid #ec4899", padding: "0.6rem", fontWeight: "600", textDecoration: "none", fontSize: "0.9rem" }}
                  >
                    View Details
                  </Link>
                  <button
                    onClick={() => navigate("/contribution", { state: { selectedProjectId: project.ProjectID } })}
                    style={{ flex: 1, textAlign: "center", borderRadius: "6px", background: "#7393ff", color: "black", border: "none", padding: "0.6rem", fontWeight: "700", cursor: "pointer", fontSize: "0.9rem" }}
                  >
                    Contribute
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p>No approved projects found.</p>
          )}
        </div>

        {/* Analytics Modal */}
        < div id="analytics-modal" className="analytics-modal" >
          <div className="analytics-content">
            <div className="close-modal" onClick={closeAnalytics}>
              <i className="fas fa-times"></i>
            </div>

            <div className="analytics-header">
              <h2 className="analytics-title">{selectedProject?.title}</h2>
              <div className="analytics-subtitle">Detailed performance metrics</div>
            </div>

            <div className="chart-container">
              <canvas id="analytics-chart"></canvas>
            </div>

            <div className="analytics-stats">
              <div className="stat-card">
                <div className="stat-label">Total Contributions</div>
                <div className="stat-value">
                  {selectedProject?.totalContributions || 0}
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Current Value</div>
                <div className="stat-value">
                  {selectedProject?.currentValue || 0}
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-label">ROI</div>
                <div className="stat-value">{selectedProject?.roi || 0}%</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Next Payment</div>
                <div className="stat-value">{selectedProject?.nextPayment || "-"}</div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default DiscoverPage;
